export default __webpack_public_path__ + "static/media/viber.22af82dc.svg";